import { useParams } from "react-router-dom";
import { FixedHeaderFooterApplicationLayout } from "../common-ui/layouts/FixedHeaderFooterApplicationLayout";
import { EodIframeFooter } from "../components/eodiframe/EodIframeFooter";
import { FloatingLogo } from "../components/eodiframe/FloatingLogo";
import { ProductDetails } from "../components/eodiframe/ProductDetails";
import { ProductPreview } from "../components/eodiframe/ProductPreview";
import { ProductScreen } from "./ProductScreen";
import { useEffect, useState } from "react";
import { usePersonalizationData } from "../hooks/usePersonalizationData";
import { DisplayErrors } from "../components/errors/DisplayErrors";
import { APIError } from "../hooks/useErrorMessageMapping";
import { usePageErrors } from "../components/errors/PageErrorContext";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import LoadingDefaultSpinIndicator from "../components/loader/LoadingDefaultSpinIndicator";

type EodIframeProps = {};

const ErrorWrapper = styled.div`
margin-top:80px;
`

export const EodIframe: React.FC<EodIframeProps> = ({ }) => {

  const { api_key, personalization_id } = useParams<{ api_key: string; personalization_id: string }>();
  const { mapAndSetErrors, formErrors } = usePageErrors()
  const { t } = useTranslation()

  const [isValidated, setIsValidated] = useState(false);

  useEffect(() => {
    try {

      // If api_key or _id is missing, show alert
      if (!api_key || !personalization_id) {

        const errorInfo: APIError[] = [{
          "key": "missing_info",
          "source": "missing_info",
          "message": t("error.infoMissing")
        }]
        mapAndSetErrors(errorInfo)

        setIsValidated(true);
        return
      }
      // keys exist  validation done
      setIsValidated(true);
    }
    catch (e: any) {
      console.log("EodIframe useEffect Line 36 - Catch exception : " + JSON.stringify(e))
      const catchExceptionInfo: APIError[] = [{
        "key": "missing_info_catch_exception",
        "source": "missing_info_catch_exception",
        "message": t("exception.message") + (e)
      }]
      mapAndSetErrors(catchExceptionInfo)
      setIsValidated(true);
      return
    }

  }, [api_key, personalization_id,]);

  // Callback function to handle the success of image data fetch
  const handleImageDataSuccess = (data: any) => {
    // Check if melco_machine_callback function exists on the global window object
    if (typeof window.melco_machine_callback === 'function') {
      window.melco_machine_callback(data);  // Call the parent app's melco_machine_callback function with the data
    } else {
      const errorInfo: APIError[] = [{
        "key": "missing_callback",
        "source": "missing_callback",
        "message": t("error.melcoMachineCallbackMissing")
      }]
      mapAndSetErrors(errorInfo)
      console.error('The melco_machine_callback callback function is not defined in the parent app.');
    }
  };

  const { data: response, isLoading, isFetching, error } = usePersonalizationData(api_key!, personalization_id!, handleImageDataSuccess);

  if (!isValidated || isLoading || isFetching) {
    return <LoadingDefaultSpinIndicator isShown={true} />
  }

  const shouldShowErrors =
    (formErrors && formErrors?.globalErrorMessages?.length > 0) || error;

  if (shouldShowErrors) {
    return (
      <FixedHeaderFooterApplicationLayout>
        <FloatingLogo />
        <ErrorWrapper>
          <DisplayErrors />
        </ErrorWrapper>
      </FixedHeaderFooterApplicationLayout>
    );
  }

  return (
    <>
      <FixedHeaderFooterApplicationLayout
        footer={
          <EodIframeFooter
            api_key={api_key}
            personalization_id={personalization_id}
          />
        }>
        <FloatingLogo />

        <ProductScreen
          product={<ProductPreview
            error={error}
            isLoading={isLoading}
            previewData={response}
            personalization_id={personalization_id!}
          />}
          content={<ProductDetails data={response?.data} />}
        />

      </FixedHeaderFooterApplicationLayout>
    </>
  );
};
